import { bool, exact, number, object, string } from 'prop-types';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { RichText, Text } from '@sitecore-jss/sitecore-jss-react';

import OrderDetail from './OrderDetail';
import { getDateRichText } from './utils';
import Global from '@utils/global';

const SaveSOSuccessBody = ({ layoutData, cartData, orderDetail, isShowOrderSummary = true, isOrderSent }) => {
  const { soCartStatuses } = useSelector((state) => state.cpSaleOrderStatusesReducer);

  const orderIdText = useMemo(() => {
    const orderIdTextValue = layoutData?.['Order id']?.value;

    return {
      ...layoutData?.['Order id'],
      value: orderIdTextValue?.replace('{orderId}', isOrderSent ? layoutData?.SaleOrder?.Cart?.SalesOrderId : cartData.SalesOrderId)
    };
  }, [cartData, layoutData]);

  const createdExpiredOrderText = useMemo(() => {
    const createAndExpireTextValue = layoutData?.['Create and expire date']?.value;

    return {
      ...layoutData?.['Create and expire date'],
      value: createAndExpireTextValue
        ?.replace(
          '{createdAt}',
          isOrderSent ? Global.formatDateDDMMMYYYY(layoutData?.SaleOrder?.Cart?.CreatedDate) : getDateRichText(cartData.CreatedDate)
        )
        ?.replace(
          '{expriredAt}',
          isOrderSent ? Global.formatDateDDMMMYYYY(layoutData?.SaleOrder?.Cart?.CreatedDate) : getDateRichText(cartData.ExpiredDate)
        )
    };
  }, [cartData, layoutData]);

  const packagesNumberText = useMemo(() => {
    const packagesCountTextValue = layoutData?.['Package count']?.value;

    return {
      ...layoutData?.['Package count'],
      value: packagesCountTextValue?.replace('{lineNumber}', isOrderSent ? layoutData?.SaleOrder?.Cart?.Lines?.length : cartData.CartLineLength)
    };
  }, [cartData, layoutData]);

  const sentMailStatusText = useMemo(() => {
    const statusData = {
      0: layoutData?.['Draft'],
      1: layoutData?.['Active'],
      2: layoutData?.['Viewed'],
      3: layoutData?.['Completed'],
      4: layoutData?.['Expired']
    };

    return isOrderSent ? statusData?.[layoutData?.SaleOrder?.Cart?.CartStatus]?.value : soCartStatuses?.[cartData.CartStatus];
  }, [layoutData, soCartStatuses, cartData]);

  return (
    <div className='save-so-success__body'>
      <div className='order-info'>
        <Text tag='h6' field={orderIdText} className='order-info__id' />
        <RichText tag='p' field={createdExpiredOrderText} className='order-info__description created-expired' />
        <Text tag='p' field={packagesNumberText} className='order-info__description' />
        <p className='order-info__description'>{sentMailStatusText}</p>
      </div>
      {isShowOrderSummary && <OrderDetail layoutData={layoutData} cartData={cartData} isOrderSent={isOrderSent} orderDetail={orderDetail} />}
    </div>
  );
};

SaveSOSuccessBody.propTypes = {
  layoutData: object,
  isOrderSent: bool,
  cartData: exact({
    SalesOrderId: string,
    CreatedDate: string,
    ExpiredDate: string,
    CartLineLength: number,
    CartStatus: number
  }),
  orderDetail: exact({
    DeliveryFee: string,
    Discount: string,
    SalesTax: string,
    Subtotal: string,
    Total: string
  }),
  isShowOrderSummary: bool
};

export default SaveSOSuccessBody;
